import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { HashLink } from "react-router-hash-link";
import classNames from "classnames";
import styled from "styled-components";
import { useSelector } from "react-redux";

const LinkListNav = ({ isBottomPage }) => {
  const { lang } = useSelector((state) => ({
    lang: state.changeLang.language.stepTwo.linkList,
  }));
  const sections = [
    ["head", lang[26]],
    ["links", lang[11]],
    ["social", lang[27]],
    ["design", lang[0]],
    ["info", lang[28]],
  ];
  const [activeSection, setactiveSection] = useState(0);

  const setUrl = () => {
    const url = window.location.pathname + window.location.search;
    setTimeout(() => {
      history.pushState({}, null, url);
    }, 300);
  };

  useEffect(() => {
    let cleanup = false;
    if (isBottomPage) {
      setactiveSection(sections.length - 1);
      return;
    }

    const elements = sections.map((item) =>
      document.querySelector(`#${item[0]}`)
    );

    const imageObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !cleanup) {
            setactiveSection(
              sections.findIndex((item) => item[0] === entry.target.id)
            );
          }
        });
      },
      {
        rootMargin: "-50% 0px -50% 0px",
      }
    );
    elements.forEach((item) => {
      if (item) {
        imageObserver.observe(item);
      }
    });
    return () => (cleanup = true);
  }, [isBottomPage]);

  return (
    <div
      className="bg-white position-sticky left-0"
      style={{ top: 90, zIndex: 480 }}
    >
      <CustomRow className="px-1 px-md-4 py-3">
        {sections.map((item, index) => (
          <Col5 key={item[0]} className="px-0 px-md-2">
            <HashLink
              className={classNames(
                "d-flex justify-content-center fw-bold py-2 rounded-1 cursor-pointer text-decoration-none fs-7 fs-md-6 text-nowrap text-capitalize",
                {
                  "bg-primary2 text-primary": activeSection === index,
                  "text-black-title": activeSection !== index,
                }
              )}
              onClick={setUrl}
              scroll={(el) =>
                el.scrollIntoView({ behavior: "auto", block: "center" })
              }
              to={`/link-list#${item[0]}`}
            >
              {item[1]}
            </HashLink>
          </Col5>
        ))}
      </CustomRow>
    </div>
  );
};

export default LinkListNav;

const CustomRow = styled(Row)`
  @media (max-width: 767px) {
    background-color: white;
  }
`;

const Col5 = styled(Col)`
  width: 20% !important;
`;
